(() => {
    const copy = document.querySelector('.estate-copy');
    const visual = document.querySelector('.estate-visual');
    const desktop = window.matchMedia('(min-width: 921px)');

    function syncEstateVisualHeight() {
      if (!copy || !visual) return;

      if (!desktop.matches) {
        visual.style.removeProperty('--estate-visual-height');
        return;
      }

      const copyHeight = Math.round(copy.getBoundingClientRect().height);
      const trimValue = getComputedStyle(document.documentElement).getPropertyValue('--estate-visual-optical-trim');
      const opticalTrim = Number.parseFloat(trimValue) || 0;
      const visualHeight = Math.max(260, Math.round(copyHeight - opticalTrim));

      /* Optical alignment: the caption's visible text was sitting slightly lower than the final paragraph glyphs. The figure is therefore
         trimmed to visually align the caption baseline near the paragraph bottom, not the copy box's mathematical bottom. */
      visual.style.setProperty('--estate-visual-height', `${visualHeight}px`);
    }

    window.addEventListener('load', syncEstateVisualHeight);
    window.addEventListener('resize', syncEstateVisualHeight);
    desktop.addEventListener?.('change', syncEstateVisualHeight);

    if ('ResizeObserver' in window && copy) {
      new ResizeObserver(syncEstateVisualHeight).observe(copy);
    }

    requestAnimationFrame(syncEstateVisualHeight);
  })();


  (() => {
    const mobileQuery = window.matchMedia('(max-width: 980px)');

    function getMenuParts(header) {
      if (!header) return {};
      const menuButton = header.querySelector('[data-menu-button]');
      return {
        menuButton,
        menuLabel: menuButton?.querySelector('[data-menu-label]'),
        mobileMenu: header.querySelector('[data-mobile-menu]')
      };
    }

    function setMenuOpen(header, open, restoreFocus = false) {
      const { menuButton, menuLabel, mobileMenu } = getMenuParts(header);
      if (!menuButton || !mobileMenu) return;
      const shouldOpen = Boolean(open && mobileQuery.matches);

      document.documentElement.classList.toggle('mobile-menu-open', shouldOpen);
      document.body.classList.toggle('mobile-menu-open', shouldOpen);
      menuButton.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      menuButton.setAttribute('aria-label', shouldOpen ? 'Close navigation menu' : 'Open navigation menu');
      mobileMenu.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');

      if (menuLabel) menuLabel.textContent = shouldOpen ? 'Close' : 'Menu';
      if (!shouldOpen && restoreFocus) menuButton.focus();
    }

    function closeEveryMenu(restoreFocus = false) {
      document.querySelectorAll('[data-site-header]').forEach(header => {
        setMenuOpen(header, false, restoreFocus);
      });
    }

    document.querySelectorAll('[data-site-header]').forEach(header => {
      setMenuOpen(header, false);
    });

    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;

      const menuButton = event.target.closest('[data-menu-button]');
      if (menuButton) {
        const header = menuButton.closest('[data-site-header]');
        setMenuOpen(header, menuButton.getAttribute('aria-expanded') !== 'true');
        return;
      }

      const mobileLink = event.target.closest('[data-mobile-menu] a');
      if (mobileLink) {
        setMenuOpen(mobileLink.closest('[data-site-header]'), false);
      }
    });

    document.addEventListener('pointerdown', event => {
      if (!(event.target instanceof Element)) return;
      document.querySelectorAll('[data-menu-button][aria-expanded="true"]').forEach(menuButton => {
        const header = menuButton.closest('[data-site-header]');
        if (header && !header.contains(event.target)) setMenuOpen(header, false);
      });
    });

    window.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const openButton = document.querySelector('[data-menu-button][aria-expanded="true"]');
      if (openButton) setMenuOpen(openButton.closest('[data-site-header]'), false, true);
    });

    mobileQuery.addEventListener?.('change', event => {
      if (!event.matches) closeEveryMenu();
    });

    document.addEventListener('shopify:section:load', event => {
      const header = event.target.querySelector?.('[data-site-header]');
      if (header) setMenuOpen(header, false);
    });

    document.addEventListener('shopify:section:unload', () => {
      closeEveryMenu();
    });
  })();


  (() => {
    function setActive(section) {
      const navLinks = [...document.querySelectorAll('.nav a[data-section-link]')];
      navLinks.forEach(link => {
        const target = link.getAttribute('data-section-link');
        link.classList.toggle('is-active', target === section);
      });
    }

    function updateHeaderState() {
      const header = document.querySelector('[data-site-header]');
      if (!header) return;
      const trackedSections = [...document.querySelectorAll('.nav a[data-section-link]')]
        .map(link => {
          const id = link.getAttribute('data-section-link');
          return { id, el: id ? document.getElementById(id) : null };
        })
        .filter((section, index, sections) => (
          section.el && sections.findIndex(candidate => candidate.id === section.id) === index
        ));
      const scrolled = window.scrollY > 12;
      header.classList.toggle('is-scrolled', scrolled);

      const headerHeight = header.getBoundingClientRect().height || 92;
      const trigger = headerHeight + 72;
      let active = null;

      trackedSections.forEach(section => {
        if (section.el.getBoundingClientRect().top <= trigger) {
          active = section.id;
        }
      });

      setActive(active);
    }

    window.addEventListener('load', updateHeaderState);
    window.addEventListener('scroll', updateHeaderState, { passive: true });
    window.addEventListener('resize', updateHeaderState);
    requestAnimationFrame(updateHeaderState);
  })();

(() => {
    const target = document.querySelector('.lineage-row:last-child');
    const secondaryImage = document.querySelector('.heritage-image-secondary');
    const secondaryCaption = document.querySelector('.heritage-caption--secondary');
    const desktop = window.matchMedia('(min-width: 921px)');
    let frame = null;

    function alignHeritageArchivePair() {
      if (!target || !secondaryImage || !secondaryCaption) return;
      if (frame) cancelAnimationFrame(frame);

      frame = requestAnimationFrame(() => {
        secondaryImage.style.removeProperty('--heritage-secondary-align-offset');

        if (!desktop.matches) return;

        requestAnimationFrame(() => {
          const targetBottom = target.getBoundingClientRect().bottom;
          const captionText = secondaryCaption.querySelector('span:first-child') || secondaryCaption;
          const captionBottom = captionText.getBoundingClientRect().bottom;
          const delta = Math.round(targetBottom - captionBottom);
          const clampedDelta = Math.max(-70, Math.min(180, delta));
          secondaryImage.style.setProperty('--heritage-secondary-align-offset', `${clampedDelta}px`);
        });
      });
    }

    window.addEventListener('load', alignHeritageArchivePair);
    window.addEventListener('resize', alignHeritageArchivePair);
    desktop.addEventListener?.('change', alignHeritageArchivePair);
    document.fonts?.ready?.then(alignHeritageArchivePair);

    document.querySelectorAll('.heritage-visual img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', alignHeritageArchivePair, { once: true });
    });

    if ('ResizeObserver' in window && target) {
      new ResizeObserver(alignHeritageArchivePair).observe(target);
    }
  })();
